var render, staticRenderFns
import script from "./dev-mode-wrap.vue?vue&type=script&lang=js"
export * from "./dev-mode-wrap.vue?vue&type=script&lang=js"
import style0 from "./dev-mode-wrap.vue?vue&type=style&index=0&id=2cb2e6a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb2e6a6",
  null
  
)

export default component.exports